import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import img1 from '../../Assets/service/taxconsult.jpg';
import img2 from '../../Assets/service/bookkeeping.jpg';
import img3 from '../../Assets/service/taxpersonal.jpg';
import img4 from '../../Assets/service/businessregi.jpg';
import img5 from '../../Assets/service/Loans.jpg';
import img6 from '../../Assets/service/RentalProperty.jpg';
import img7 from '../../Assets/service/auditing.jpg';
import img8 from '../../Assets/service/payroll.jpg';
import img9 from '../../Assets/service/planning.jpg';
import img10 from '../../Assets/service/corporatedocum.jpg';
import img11 from '../../Assets/service/hrconsulting.jpg';
import img12 from '../../Assets/service/itservices.jpg';
import magizhiniLogo from '../../Assets/service/magizhini_logo.png';
import './service.css';

const allServices = [
    { id: 1,  title: "Tax Consulting",             img: img1,  desc: "Personalized strategies to optimize your tax liabilities and ensure full regulatory compliance.",        number: "01" },
    { id: 2,  title: "Bookkeeping Services",        img: img2,  desc: "Accurate and efficient tracking of your financial transactions and records for clear insights.",          number: "02" },
    { id: 3,  title: "Taxes",                       img: img3,  desc: "Comprehensive tax services tailored for individuals, businesses, and corporations of every size.",        number: "03" },
    { id: 4,  title: "Business Registration",       img: img4,  desc: "Streamlined assistance in registering and structuring your new business for long-term success.",         number: "04" },
    { id: 5,  title: "Loans & Mortgages",           img: img5,  desc: "Navigating the complexities of loans and mortgages with expert guidance every step of the way.",        number: "05" },
    { id: 6,  title: "Rental Property HST Rebates", img: img6,  desc: "Maximize your returns on rental property investments with expert HST rebate management.",               number: "06" },
    { id: 7,  title: "Auditing",                    img: img7,  desc: "Thorough examinations of your financial statements to ensure accuracy, transparency, and compliance.",   number: "07" },
    { id: 8,  title: "Payroll Management",          img: img8,  desc: "Efficient and reliable payroll processing and compliance services for businesses of all sizes.",         number: "08" },
    { id: 9,  title: "Tax Planning & Reporting",    img: img9,  desc: "Strategic financial planning and detailed reporting to empower informed business decision-making.",      number: "09" },
    { id: 10, title: "Legally Required",         img: img10, desc: "Expert preparation and management of essential corporate documents to keep your business compliant.",    number: "10" },
    { id: 11, title: "Strategic HR Consulting",    img: img11, desc: "Bridging the gap between your bottom line and your best assets with compliance, talent, and strategic HR solutions.", number: "11" },
    { id: 12, title: "IT Services Partnering",     img: img12, desc: "Empowering businesses through our strategic IT partnership with Magizhini Tech for custom software development, cloud, and digital solutions.", number: "12" },
];

const TaxServices = () => {
    const cardsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('svc-card--visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );

        cardsRef.current.forEach((card) => {
            if (card) observer.observe(card);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <section className="svc-section">
            {/* ── section header ── */}
            <div className="svc-header">
                <span className="svc-header__label">SERVICES</span>
                <h2 className="svc-header__title">Our Tax Services</h2>
                <p className="svc-header__sub">
                    Expert tax planning, preparation, and compliance services tailored to your unique
                    needs for optimal financial outcomes.
                </p>
                <div className="svc-header__line" />
            </div>

            {/* ── grid ── */}
            <div className="svc-grid container-xxl">
                {allServices.map((svc, idx) => (
                    <div
                        key={svc.id}
                        className="svc-card"
                        ref={(el) => (cardsRef.current[idx] = el)}
                        style={{ '--delay': `${idx * 80}ms` }}
                    >
                        {/* background image */}
                        <div className="svc-card__img-wrap">
                            <img src={svc.img} alt={svc.title} className="svc-card__img" />
                            <div className="svc-card__overlay" />
                        </div>

                        {/* Magizhini Partner Logo Badge for Card 12 */}
                        {svc.id === 12 && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '16px',
                                    left: '16px',
                                    zIndex: 5,
                                    background: '#ffffff',
                                    padding: '8px 16px',
                                    borderRadius: '10px',
                                    boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src={magizhiniLogo}
                                    alt="Magizhini Technology Services Logo"
                                    style={{ height: '44px', width: 'auto', objectFit: 'contain' }}
                                />
                            </div>
                        )}

                        {/* number badge */}
                        <span className="svc-card__num">{svc.number}</span>

                        {/* content revealed on hover */}
                        <div className="svc-card__body">
                            <h3 className="svc-card__title">{svc.title}</h3>
                            <p className="svc-card__desc">{svc.desc}</p>
                            <Link
                                to={`/servicedetails/${svc.id}`}
                                className="svc-card__btn"
                            >
                                View Details
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                </svg>
                            </Link>
                        </div>

                        {/* bottom accent bar */}
                        <div className="svc-card__bar" />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TaxServices;